import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPT_IN_ENABLED = defineFcm('double_opt_in_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: ['corgi-front-end', 'monorail'],
		context: 'petition page',
		description:
			'For guests only, indicates whether to display a reminder to check the email inbox to confirm the signature.',
		import: false,
	});
